let initializedId = null;

export const initGA4 = (measurementId) => {
  if (!measurementId || initializedId === measurementId) return;
  if (typeof window === 'undefined') return;

  if (!document.getElementById('ga4-script')) {
    const script = document.createElement('script');
    script.id = 'ga4-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    linker: { domains: ['mysms360.com'], accept_incoming: true },
    send_page_view: true,
  });
  initializedId = measurementId;
};

export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
};

export const getUtmParams = () => {
  if (typeof window === 'undefined') return {};
  const qs = new URLSearchParams(window.location.search);
  return {
    utm_source: qs.get('utm_source') || undefined,
    utm_medium: qs.get('utm_medium') || undefined,
    utm_campaign: qs.get('utm_campaign') || undefined,
    utm_content: qs.get('utm_content') || undefined,
    utm_term: qs.get('utm_term') || undefined,
    referrer: document.referrer || undefined,
  };
};
